var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Rank-container"},[_c('rank-header',{staticClass:"rank-header-class",attrs:{"masterList":_vm.masterList2.slice(0, 3),"historyWord":this.showingWords}}),_c('rank-master-list',{attrs:{"masterList":this.masterList2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }